import React, { ReactNode, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { EN, ES } from '~/core/util/localizedStr';
import { isI18NSupportedLang } from '~/locale/i18n';
import { SolvReduxState } from '~/reducers';
import { getNewBookingLocale } from '~/selectors/newBooking';

interface I18NextLangFollowsReduxProps {
  selector(state: SolvReduxState): string;
  children?: ReactNode;
}

export const I18NextLangFollowsRedux = ({ selector, children }: I18NextLangFollowsReduxProps) => {
  const newLang = useSelector(selector);
  const { i18n } = useTranslation();
  const i18nRef = useRef(i18n);
  useEffect(() => {
    i18nRef.current = i18n;
  });

  useEffect(() => {
    let lang = newLang;
    if (newLang === 'en-us') {
      lang = EN;
    }
    if (newLang === 'es-us') {
      lang = ES;
    }
    if (isI18NSupportedLang(lang)) {
      i18nRef.current.changeLanguage(lang);
    }
  }, [newLang]);

  return <>{children}</>;
};

interface I18NextLangFollowsPastBookingLangProps {
  bookingId: string;
  children?: ReactNode;
}
export const I18NextLangFollowsPastBookingLang = ({
  bookingId,
  children,
}: I18NextLangFollowsPastBookingLangProps) => {
  return (
    <I18NextLangFollowsRedux selector={(state) => state.pastBookings?.[bookingId]?.language}>
      {children}
    </I18NextLangFollowsRedux>
  );
};

interface I18NextLangFollowsNewBookingLangProps {
  children?: ReactNode;
}

export const I18NextLangFollowsNewBookingLang = ({
  children,
}: I18NextLangFollowsNewBookingLangProps) => {
  return (
    <I18NextLangFollowsRedux selector={getNewBookingLocale}>{children}</I18NextLangFollowsRedux>
  );
};
